import { render, staticRenderFns } from "./PrimaryDriverDetails.vue?vue&type=template&id=4ff3511a&scoped=true&"
import script from "./PrimaryDriverDetails.vue?vue&type=script&lang=js&"
export * from "./PrimaryDriverDetails.vue?vue&type=script&lang=js&"
import style0 from "./PrimaryDriverDetails.vue?vue&type=style&index=0&id=4ff3511a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff3511a",
  null
  
)

export default component.exports